var React = require('react');

function View (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23 28.6C27.3814 28.6 30.9333 25.0481 30.9333 20.6666C30.9333 16.2852 27.3814 12.7333 23 12.7333C18.6185 12.7333 15.0667 16.2852 15.0667 20.6666C15.0667 25.0481 18.6185 28.6 23 28.6Z","stroke":"#F9FDFF","strokeWidth":"3.25","key":0}),React.createElement("path",{"d":"M44 20.6667C44 20.6667 41.6667 2 23 2C4.33333 2 2 20.6667 2 20.6667","stroke":"#F9FDFF","strokeWidth":"3.25","key":1})]);
}

View.defaultProps = {"width":"16","height":"14","viewBox":"0 0 46 31","fill":"none"};

module.exports = View;

View.default = View;
